import { typography } from '@mehilainen/mds-tokens';
export const typographyStyles = {
    display1Mobile: {
        fontSize: typography.baseTypography.size[700].rem,
        fontWeight: typography.baseTypography.weight.Medium,
        lineHeight: typography.baseTypography.height.Medium,
    },
    display1Desktop: {
        fontSize: typography.baseTypography.size[900].rem,
        // fontWeight: typography.baseTypography.weight.Medium,
        // lineHeight: typography.baseTypography.height.Medium,
    },
    display2Mobile: {
        fontSize: typography.baseTypography.size[600].rem,
        fontWeight: typography.baseTypography.weight.Medium,
        lineHeight: typography.baseTypography.height.Medium,
    },
    display2Desktop: {
        fontSize: typography.baseTypography.size[800].rem,
        // fontWeight: typography.baseTypography.weight.Medium,
        // lineHeight: typography.baseTypography.height.Medium,
    },
    title1Mobile: {
        fontSize: typography.baseTypography.size[600].rem,
        fontWeight: typography.baseTypography.weight.Medium,
        lineHeight: typography.baseTypography.height.Medium,
    },
    title1Desktop: {
        fontSize: typography.baseTypography.size[700].rem,
        // fontWeight: typography.baseTypography.weight.Medium,
        // lineHeight: typography.baseTypography.height.Medium,
    },
    title2Mobile: {
        fontSize: typography.baseTypography.size[500].rem,
        fontWeight: typography.baseTypography.weight.Medium,
        lineHeight: typography.baseTypography.height.Medium,
    },
    title2Desktop: {
        fontSize: typography.baseTypography.size[600].rem,
        // fontWeight: typography.baseTypography.weight.Medium,
        // lineHeight: typography.baseTypography.height.Medium,
    },
    title3Mobile: {
        fontSize: typography.baseTypography.size[450].rem,
        fontWeight: typography.baseTypography.weight.Medium,
        lineHeight: typography.baseTypography.height.Medium,
    },
    title3Desktop: {
        fontSize: typography.baseTypography.size[500].rem,
        // fontWeight: typography.baseTypography.weight.Medium,
        // lineHeight: typography.baseTypography.height.Medium,
    },
    title4Mobile: {
        fontSize: typography.baseTypography.size[400].rem,
        fontWeight: typography.baseTypography.weight.Medium,
        lineHeight: typography.baseTypography.height.Medium,
    },
    title4Desktop: {
        fontSize: typography.baseTypography.size[450].rem,
        // fontWeight: typography.baseTypography.weight.Medium,
        // lineHeight: typography.baseTypography.height.Medium,
    },
    title5Mobile: {
        fontSize: typography.baseTypography.size[300].rem,
        fontWeight: typography.baseTypography.weight.Medium,
        lineHeight: typography.baseTypography.height.Medium,
    },
    title5Desktop: {
        fontSize: typography.baseTypography.size[400].rem,
        // fontWeight: typography.baseTypography.weight.Medium,
        // lineHeight: typography.baseTypography.height.Medium,
    },
    body1Mobile: {
        fontSize: typography.baseTypography.size[400].rem,
        fontWeight: typography.baseTypography.weight.Regular,
        lineHeight: typography.baseTypography.height.Medium,
    },
    body1Desktop: {
        fontSize: typography.baseTypography.size[450].rem,
        // fontWeight: typography.baseTypography.weight.Regular,
        // lineHeight: typography.baseTypography.height.Medium,
    },
    body2Mobile: {
        fontSize: typography.baseTypography.size[300].rem,
        fontWeight: typography.baseTypography.weight.Regular,
        lineHeight: typography.baseTypography.height.Medium,
    },
    body2Desktop: {
        fontSize: typography.baseTypography.size[400].rem,
        // fontWeight: typography.baseTypography.weight.Regular,
        // lineHeight: typography.baseTypography.height.Medium,
    },
    body3Mobile: {
        fontSize: typography.baseTypography.size[200].rem,
        fontWeight: typography.baseTypography.weight.Regular,
        lineHeight: typography.baseTypography.height.Medium,
    },
    body3Desktop: {
        fontSize: typography.baseTypography.size[300].rem,
        // fontWeight: typography.baseTypography.weight.Regular,
        // lineHeight: typography.baseTypography.height.Medium,
    },
    caption: {
        fontSize: typography.baseTypography.size[400].rem,
        fontWeight: typography.baseTypography.weight.Regular,
    },
    label: {
        fontSize: typography.baseTypography.size[300].rem,
        fontWeight: typography.baseTypography.weight.Regular,
    },
    footnoteMobile: {
        fontSize: typography.baseTypography.size[100].rem,
        fontWeight: typography.baseTypography.weight.Regular,
        lineHeight: typography.baseTypography.height.Medium,
    },
    footnoteDesktop: {
        fontSize: typography.baseTypography.size[200].rem,
    },
};
